import { Grid } from 'antd'

// Single source of truth for the app's mobile breakpoint (Ant Design `md` = 768px).
// Returns true only once breakpoints have resolved below 768px. We check
// `screens.md === false` rather than `!screens.md` so the initial (unresolved)
// `{}` reads as desktop, avoiding a mobile-layout flash on first paint.
export default function useIsMobile() {
  const screens = Grid.useBreakpoint()
  return screens.md === false
}
